import VenueReviews from './VenueReviews';

export default VenueReviews;
